import { FC } from "react";

import { Box, useMultiStyleConfig } from "@chakra-ui/react";

import Icon from "@components/Icon";
import Link from "@components/Link";

import { TSubmittedViewProps } from "./types";

const SubmittedView: FC<TSubmittedViewProps> = ({ id, removeLabel, value, onRemove }) => {
  const styles = useMultiStyleConfig("SubmitInput", {});

  const handleRemove = () => {
    onRemove();
  };

  return (
    <Box sx={styles.submittedViewWrapper} id={id && `submitted-${id}`}>
      <Icon icon="success" size="1.125rem" />
      <Box sx={styles.submittedViewValue}>{value}</Box>
      <Link variant="red" size="md" label={removeLabel} id={id && `submitted-link-${id}`} onClick={handleRemove} />
    </Box>
  );
};
export default SubmittedView;
